import { notificationDesign } from '../../utils/notificationDesign';
import { App } from 'antd';

const PLACEMENT_MAP = {
  'bottom-left': 'bottomLeft',
  'bottom-right': 'bottomRight',
  'top-left': 'topLeft',
  'top-right': 'topRight',
  'top-center': 'top',
  'bottom-center': 'bottom',
};

// No-op — Ant Design manages its own portal; existing <ToastContainer /> renders will just be invisible.
const ToastContainer = () => null;

const useSnackbar = () => {
  const { notification } = App.useApp();
  const SuccessSnackbar = (message, position = 'bottom-left') =>
    notification.success({
      ...notificationDesign('general', 'success'),
      message,
      placement: PLACEMENT_MAP[position] || 'bottomLeft',
      duration: 5,
    });

  const ErrorSnackbar = (message, position = 'bottom-left') =>
    notification.error({
      ...notificationDesign('general', 'error'),
      message,
      placement: PLACEMENT_MAP[position] || 'bottomLeft',
      duration: 5,
    });

  const InfoSnackbar = (message, position = 'bottom-left') =>
    notification.info({
      ...notificationDesign('general', 'info'),
      message,
      placement: PLACEMENT_MAP[position] || 'bottomLeft',
      duration: 5,
    });

  const WarningSnackbar = (message, position = 'bottom-left') =>
    notification.warning({
      ...notificationDesign('general', 'warning'),
      message,
      placement: PLACEMENT_MAP[position] || 'bottomLeft',
      duration: 5,
    });

  return {
    SuccessSnackbar,
    ErrorSnackbar,
    InfoSnackbar,
    WarningSnackbar,
    ToastContainer,
  };
};

export default useSnackbar;
